import { useMutation } from '@tanstack/react-query'
import { updateReturnProcess } from '@/api/returns-api'
import { ReturnsApiUpdateReturnProcessRequest } from '@itsrever/rever-api'

const updateProcess = async (req: ReturnsApiUpdateReturnProcessRequest) => {
  const data = await updateReturnProcess(req)

  return data
}

export const useUpdateProcess = () => {
  return useMutation({
    mutationFn: updateProcess
  })
}
